import React from "react";
import {observer} from "mobx-react";
import {modalActionTypeEnum} from "../../enums";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import LimitedTextField from "../Shared/LimitedTextField";
import Utility from "../../Utility";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {TextField} from "@mui/material";

const CreateEditLinkItemModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    const {modalData, procedureToBeChanged} = modalStore;
    const {name, link, permittedRolesMenu, doMainAction, actionType} = modalData;
    const modalActionType = generalStore.translate(actionType || "editLink"); // modalActionTypeEnum
    const title = actionType === modalActionTypeEnum.CREATE ? generalStore.translate('createNewLinkItem') : generalStore.translate('editLinkItem');

    const trimmedName = name && name.trim();
    const trimmedLink = link && link.trim();
    const urlValidated = Utility.validateUrl(trimmedLink);
    const formValidated = actionType === modalActionTypeEnum.CREATE ? !!trimmedName && !!trimmedLink && !!urlValidated : !!trimmedLink && !!urlValidated;


    function onEnter() {
        if (!procedureToBeChanged) {
            return;
        }
        modalStore.modalData.name = procedureToBeChanged.ProcedureName;
        modalStore.modalData.link = procedureToBeChanged.ProcedureLink;
    }

    function closeModal() {
        modalStore.isCreateEditLinkModalOpen = false;
    }


    async function confirm() {
        if (!formValidated) {
            return;
        }
        generalStore.isLoaderOpen = true;

        try {
            const success = await doMainAction(trimmedName, trimmedLink);
            if (success) {
                generalStore.isLoaderOpen = false;
                closeModal();
            }
        } catch (e) {
            console.error(e);
        }

        generalStore.isLoaderOpen = false;
    }

    return (
        <GeneralDialog
            openControl='isCreateEditLinkModalOpen'
            className={`blue-dialog create-procedure-dialog` + (actionType !== modalActionTypeEnum.CREATE  ? ' edit' : '')}
            onEnter={onEnter}
            title={title}
            body={
                <div>
                    <ConditionalComponent if={modalActionTypeEnum.CREATE === actionType}>
                        <div className='text-field-label'>{generalStore.translate('itemName')}</div>
                        <LimitedTextField
                            variant='outlined'
                            autoFocus
                            placeholder={generalStore.translate('egScreenResolutionChanging')}
                            value={name}
                            className='name-input link-procedure-input'
                            onChange={e => modalStore.modalData.name = e.target.value}
                            originalValue={name}
                            limit={500}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </ConditionalComponent>
                    <div className='text-field-label'>{generalStore.translate('linkUrl')}</div>
                    <TextField
                        variant='outlined'
                        placeholder='https://google.com'
                        value={link}
                        className='name-input link-procedure-input'
                        onChange={e => modalStore.modalData.link = e.target.value}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />

                    <ConditionalComponent if={modalActionTypeEnum.CREATE === actionType}>
                        <span className="dialog-description">{permittedRolesMenu}</span>
                    </ConditionalComponent>
                </div>
            }
            isConfirmDisabled={!formValidated}
            onConfirm={confirm}
            confirmText={modalActionType}
            preserveDataOnClose
        />
    );
});

export default CreateEditLinkItemModal;
